import qs from "qs";
import axios from "axios";
import Jsona from "jsona";

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, { encode: false });
    },
  };

  return axios.get(`${url}/sales-deliveries`, options).then((response) => {
    return {
      list: jsona.deserialize(response.data),
      meta: response.data.meta,
    };
  });
}

function get(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/sales-deliveries/${id}?include=organization,recipient,items,items.salesDeliverable,allowedLocations,salesOrder,sourceWarehouse`,
      options
    )
    .then((response) => {
      let delivery = jsona.deserialize(response.data);
      delete delivery.links;
      return delivery;
    });
}

function add(delivery) {
  const payload = jsona.serialize({
    stuff: delivery,
    includeNames: null,
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .post(`${url}/sales-deliveries`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function update(delivery) {
  const payload = jsona.serialize({
    stuff: delivery,
    includeNames: [],
  });

  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .patch(`${url}/sales-deliveries/${delivery.id}`, payload, options)
    .then((response) => {
      return jsona.deserialize(response.data);
    });
}

function destroy(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios.delete(`${url}/sales-deliveries/${id}`, options);
}

function validate(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/sales-deliveries/${id}/validate?include=organization,recipient,items,allowedLocations,salesOrder`,
      options
    )
    .then((response) => {
      let delivery = jsona.deserialize(response.data);
      delete delivery.links;
      return delivery;
    });
}

function cancel(id) {
  const options = {
    headers: {
      Accept: "application/vnd.api+json",
      "Content-Type": "application/vnd.api+json",
    },
  };

  return axios
    .get(
      `${url}/sales-deliveries/${id}/cancel?include=organization,recipient,items,allowedLocations,salesOrder`,
      options
    )
    .then((response) => {
      let delivery = jsona.deserialize(response.data);
      delete delivery.links;
      return delivery;
    });
}

export default {
  list,
  get,
  add,
  update,
  destroy,
  validate,
  cancel,
};
